import { Checkbox } from "@mui/material";
import { Tooltip } from "components/Tooltip";

export const CustomCheckBox = ({
  limitExceeded,
  selectedRows,
  onChange,
  row,
}) => {
  const disableCheckAction = limitExceeded && !selectedRows?.[row.id];
  return (
    <Tooltip.Info
      title="Limite de itens alcançado"
      description="Desmarque outros itens para selecionar este"
      show={limitExceeded && !!selectedRows?.[row.id] === false}
    >
      <Checkbox
        checked={!!selectedRows?.[row.id]}
        onChange={() => !disableCheckAction && onChange(row.id)}
      />
    </Tooltip.Info>
  );
};
